import permissions from 'config/permissions';
import { isProduction } from 'utils/env';
import {
	openAdvancedSearchTab,
	openCorezoidTab,
	openSenderAdminTab,
	openVideoCallTab,
} from 'actions/tabs';

const sdsAccessPermissions = [
	permissions.AdminOperations.role_admin,
	permissions.AdminKbOperations.action_editKnowledgeBase,
	permissions.AdminOperations.action_editKnowledgeBase,
	permissions.EducationOperations.action_manage,
];

const analyticsAccessPermissions = [
	permissions.AdminOperations.role_admin,
	permissions.AnalyticsModulesOperations.action_manage_dashboard,
	permissions.AnalyticsModulesOperations.action_manage_report_templates,
	permissions.AnalyticsModulesOperations.action_manage_report_designer,
	permissions.AnalyticsModulesOperations.action_manage_cartograms,
];

const analyticsAccessGroups = ['Analytics_modules', 'AnaliticUKC'];

const advancedSearchAccessPermissions = [
	permissions.AdminOperations.role_admin,
	permissions.SearchOperations.search_appeal,
];

export const customerLinks = [
	{
		id: '28241843',
		name: 'dashboard',
		title: 'Панель моніторингу',
		description: 'Статистичні дані',
	},
	{
		id: '28735821',
		name: 'appeal',
		title: 'Звернення',
		description: 'Звернення заявників',
	},
	{
		id: '28241842',
		name: 'knowledge_base',
		title: 'База знань',
		description: 'База знань',
	},
	{
		id: '28242334',
		name: 'identity',
		title: 'Ідентіті',
		description: 'Ідентіті',
		permission: permissions.AdminGrantOperations.action_manage_access,
	},
	{
		id: '28242334',
		name: 'sds',
		title: 'SDS',
		description: 'SDS',
		link: isProduction ? 'https://new-crm-prod.ukc.loc/sds/app/' : 'https://new-crm.ukc.loc/sds/app/',
		permission: sdsAccessPermissions,
	},
	{
		id: '61669934',
		name: 'advanced-search/1/',
		title: 'Пошук',
		description: 'Розширений пошук',
		permission: advancedSearchAccessPermissions,
		onClick: () => openAdvancedSearchTab(1),
	},
	{
		id: '61681409',
		name: 'advanced-report',
		title: 'Звітність',
		description: 'Звітність',
		permission: analyticsAccessPermissions,
		groups: analyticsAccessGroups,
	},
	{
		id: '61690274',
		name: 'learning',
		title: 'Навчання',
		description: 'Навчання',
		permission: permissions.EducationOperations.action_manage,
	},
	{
		id: '61691264',
		name: 'video-call',
		title: 'Відеодзвінок',
		description: 'Відеодзвінок',
		permission: permissions.VideoCallsOperations.action_manage,
		onClick: openVideoCallTab,
	},
	{
		id: '61691265',
		name: 'corezoid',
		title: 'Sender',
		description: 'Sender',
		permission: permissions.ChatOperations.action_manage,
		onClick: openCorezoidTab,
	},
	{
		id: '61691266',
		name: 'sender-admin',
		title: 'Sender Admin',
		description: 'Sender Admin',
		permission: permissions.ChatOperations.action_manage,
		onClick: openSenderAdminTab,
	},
];

export const settingsLink = {
	id: '123151',
	name: 'settings',
	title: 'settings',
	description: '',
	link: '/settings/controlUsers/domains',
};

export const settingsNavigation = [
	{
		name: 'controlUsers',
		route: '/settings/controlUsers',
		id: 1,
		exact: true,
		children: [
			{
				name: 'domains',
				route: '/settings/controlUsers/domains',
				id: 101,
			},
			{
				name: 'groups',
				route: '/settings/controlUsers/groups',
				id: 102,
			},
			{
				name: 'users',
				route: '/settings/controlUsers/users',
				id: 103,
			},
			{
				name: 'roles',
				route: '/settings/controlUsers/roles',
				id: 104,
			},
			{
				name: 'bu',
				route: '/settings/controlUsers/bu',
				id: 105,
			},
		],
	},
];
